import React, { forwardRef } from "react"

export interface ContainerProps {
  /**
   * Additional classnames for the container
   */
  className?: string
  /**
   * The content of the container
   */
  children?: React.ReactNode
  /**
   * The size of the container
   * @default "default"
   */
  width?: "sm" | "md" | "lg" | "default"
  /**
   * Additional styles for the container
   */
  style?: React.CSSProperties
}

/**
 * Returns the max-width for the container based the `<Container />`’s `width` prop
 */
export const getMaxContainerWidth = (
  width: ContainerProps["width"] = "default"
) => {
  switch (width) {
    case "sm":
      return 750
    case "md":
      return 864
    case "lg":
      return 992
    case "default":
    default:
      return 1168
  }
}

/**
 * The main container of content on a page.
 */
const Container = forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, children, width, ...other }, ref) => {
    const _className = `
    ${
      {
        sm: "lg:max-w-[48.875rem]",
        md: "lg:max-w-4xl",
        lg: "xl:max-w-5xl",
        default: "",
      }[width || "default"]
    }
    ${className}
  `
    return (
      <div
        ref={ref}
        className={`container mx-auto px-4 ${_className}`}
        {...other}
      >
        {children}
      </div>
    )
  }
)

export default Container
